export const DEFAULT_LAYOUT_COL_STYLE_VALUE = '1fr';
export const DEFAULT_LAYOUT_ROW_STYLE_VALUE = 'auto';
